module.exports = __webpack_public_path__ + "static/media/12.score.5d5ee1ef.mp4";